import React from 'react';
import { useRef } from "react";
import * as HELPERS from "../../helper_functions/helper_functions";

const Notes = ({ notes, updateNotes, handleNotes }) => {
  const textareaEl = useRef(null);
  
  let addNote = () => {
    if (!textareaEl.current.value) return
    const newNote = {
      note: textareaEl.current.value,
      id: HELPERS.randomID(),
      date: HELPERS.currentDate()
    }
    textareaEl.current.value = ''
    handleNotes({
      type: 'add',
      newNote
    })
  }

  return(
    <div className="notes">
      {updateNotes && 
      <>
      <textarea
        placeholder="Add New Note . . .✎"
        ref={textareaEl}
      ></textarea>
      <button onClick={addNote}>ADD</button>
      </>}
      {notes.length === 0 && 
        <p className="note">Add Notes and they will appear here</p>
      }
      {notes.length > 0 &&
        notes.map((n) => (
          <div className="note" key={n.id}>
            <p className="note-value">{n.note}</p>
            <p className="note-date">{n.date}</p>
            {updateNotes && <button onClick={() => handleNotes({type: 'remove', id: n.id})}>✕</button>}
          </div>
        ))
      }
    </div>
  )
}

export default Notes;